"use client"

import {useEffect} from "react";

interface SetIPProps {
    ip: string;
}

export const SetIP = (T: SetIPProps) => {
    useEffect(() => {
            localStorage.setItem("ipV4", T.ip);
        }, []
    )

    return <></>
}